import { Component, OnInit } from '@angular/core';
import { FieldWrapper } from '@ngx-formly/core';
import { AdUser, ImmigrationApi } from 'src/app/core/api.gen';
import { CommonService } from 'src/app/core/common.service';


@Component({
  selector: 'eos-button-field-wrapper',
  templateUrl: './button-field-wrapper.component.html',
  styleUrls: ['./button-field-wrapper.component.css']
})
export class ButtonFieldWrapperComponent extends FieldWrapper {
  constructor(public common: CommonService) {
    super();
  }

  public get hasValue(): boolean {
    return !!this.formControl.value;
  }


  public searchClicked() {
    return this.formControl.value;
  }

}
